import { createContext, useContext } from 'react';

/**
 * Wave 5 — the PRIMARY set's id, for the links that open a rule when the hit does not say which
 * set fired it (`ruleLink`, `rulePath`). The shell provides it: its document's `ruleSetId`, else
 * the registry's primary. `null` = not known yet (outside the shell, or still loading).
 */
export const PrimarySetContext = createContext<string | null>(null);

export function usePrimarySetId(): string | null {
  return useContext(PrimarySetContext);
}
